import axios from 'axios';
import Vue from 'vue';
import {
  Message,
  Loading,
} from 'element-ui';
import Rsa from '@/utils/rsa.js';
import crypto from '@/utils/crypto.js';

import router from '../router';

/* eslint-disable */
class requstHelper {
  static fetch = (url, data, option = {}) => {
    const initKey = crypto.generatekey(32);
    let key = Rsa.jiami(initKey);
    // 调用加密函数
    // const encrypted = crypto.aesEncrypt(btoa(encodeURIComponent(JSON.stringify(data))), initKey);
    // const encrypted = crypto.aesEncrypt(data, initKey);
    const encrypted = btoa(encodeURIComponent(JSON.stringify(data)))
    // 控制台输出查看结果
    // console.log('POST请求aes加密结果: ', 'initKey:', initKey, 'key:', key, 'data:', data, encrypted);
    let dataMy = {
      k: key,
      v: encrypted
    };
    console.log(`${process.env.API_HOST}${url}`);
    console.log('请求', option.noLoading);
    console.log(data)
    let loading = {};
    if (option.noLoading) {
      loading = Loading.service({
        lock: true,
        text: '',
        spinner: 'el-icon-loading',
        background: 'rgba(255, 255, 255, 0.8)',
      });
    }
    let reuestDataName = 'data';
    if (option.method === 'GET' || option.method === 'get') {
      reuestDataName = 'params';
    }
    return new Promise((resovle, reject) => {
      axios({
          url: `${process.env.API_HOST}${url}`, // 请求地址
          headers: option.header ? option.header : {},
          [reuestDataName]: data,
          method: option.method ? option.method : 'POST',
          dataType: option.dataType ? option.dataType : 'json',
        })
        .then((rep) => {
          console.log('请求响应', rep);
          const repData = rep.data;
          // 发生错误的场合
          if (repData.code === 0) {
            resovle(repData);
            Vue.nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
              if (option.noLoading) {
                loading.close();
              }
            });
          } else if (repData.code === 1) {
            resovle(repData);
            Vue.nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
              if (option.noLoading) {
                loading.close();
              }
            });
          } else if (repData.code === 401) {
            const msg = repData.message || repData.msg;
            Vue.nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
              if (option.noLoading) {
                loading.close();
              }
            });
            Message({
              message: msg,
              type: 'error',
              duration: 3000,
            });
            router.push({
              path: '/login'
            });
            // reject(msg);
          } else if (repData.code === 500) {
            const msg = repData.message || repData.msg;
            Vue.nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
              if (option.noLoading) {
                loading.close();
              }
            });
            // Message({
            //     message: msg,
            //     type: 'error',
            //     duration: 3000,
            // });
            if (repData.msg == '登录状态失效，请重新登录') {
              router.push({
                path: '/login'
              });
            } else {
              reject(msg);
            }
          } else {
            Vue.nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
              if (option.noLoading) {
                loading.close();
              }
            });
            const message = repData.message || repData.msg;
            reject(message);
          }
        })
        .catch((err) => {
          Vue.nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
            if (option.noLoading) {
              loading.close();
            }
          });
          reject(err);
        });
    }, );
  };
}

export default requstHelper;



// WEBPACK FOOTER //
// ./src/api/requstHelper.js